import { apiClient } from './authService';

const laboratoireService = {
  // Get all laboratoires (full list in one shot — bypass the 50-row default
  // pagination, and always return a plain array).
  getAllLaboratoires: async () => {
    try {
      const response = await apiClient.get('products/laboratoires/?page_size=5000');
      const data = response.data;
      return Array.isArray(data) ? data : (data?.results || []);
    } catch (error) {
      console.error('Error fetching laboratoires:', error);
      throw error.response?.data || { message: 'Error fetching laboratoires' };
    }
  },

  // Get laboratoire by ID
  getLaboratoireById: async (id) => {
    try {
      const response = await apiClient.get(`products/laboratoires/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching laboratoire ${id}:`, error);
      throw error.response?.data || { message: 'Error fetching laboratoire details' };
    }
  },

  // Create new laboratoire
  createLaboratoire: async (laboratoireData) => {
    try {
      const response = await apiClient.post('products/laboratoires/', laboratoireData);
      return response.data;
    } catch (error) {
      console.error('Error creating laboratoire:', error);
      throw error.response?.data || { message: 'Error creating laboratoire' };
    }
  },

  // Update laboratoire
  updateLaboratoire: async (id, laboratoireData) => {
    try {
      const response = await apiClient.put(`products/laboratoires/${id}/`, laboratoireData);
      return response.data;
    } catch (error) {
      console.error(`Error updating laboratoire ${id}:`, error);
      throw error.response?.data || { message: 'Error updating laboratoire' };
    }
  },

  // Delete laboratoire
  deleteLaboratoire: async (id) => {
    try {
      const response = await apiClient.delete(`products/laboratoires/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting laboratoire ${id}:`, error);
      throw error.response?.data || { message: 'Error deleting laboratoire' };
    }
  },
};

export default laboratoireService;
